import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Button, Space, Typography } from "antd";
import { UserOutlined, LockOutlined, SafetyOutlined } from "@ant-design/icons";
import styles from "./RegisterForm.css"; // 样式文件
import classNames from "classnames";
import { Api } from "@/api/api";
import { getUUID, showDanger, showSuccess } from "@/utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLoading } from "@/components/global-loading";

const { Link, Text } = Typography;

const LoginForm = () => {
    const [form] = Form.useForm();
    const history = useHistory();
    const captchaUuidRef = useRef();
    const [captchaUrl, setCaptchaUrl] = useState("");
    const { showLoading, hideLoading } = useLoading();

    useEffect(() => {
        fetchCaptcha();
    }, []);

    const fetchCaptcha = () => {
        showLoading();
        captchaUuidRef.current = getUUID();

        Api.user.getCaptcha(captchaUuidRef.current, (res) => {
            if (res.status === 200) {
                const blob = new Blob([res.data], { type: res.data.type });
                setCaptchaUrl(URL.createObjectURL(blob));
            } else {
                showDanger("验证码加载失败，点击刷新");
            }

            hideLoading();
        });
    };

    // 提交表单
    const onFinish = (values) => {
        showLoading("注册中");
        Api.user.register(
            {
                ...values,
                captchaId: captchaUuidRef.current,
                areaCode: "+86",
            },
            ({ data }) => {
                if (data?.code === 0) {
                    showSuccess("注册成功！");
                    history.push("/login");
                } else {
                    showDanger(data.msg || "注册失败");
                    fetchCaptcha();
                }
            },
            (err) => {
                showDanger(err.data.msg || "注册失败");
                if (
                    err.data != null &&
                    err.data.msg != null &&
                    err.data.msg.indexOf("图形验证码") > -1
                ) {
                    fetchCaptcha();
                }
            }
        );
        hideLoading();
    };

    return (
        <div className={styles.loginFormContainer}>
            <Form
                form={form}
                name="loginForm"
                onFinish={onFinish}
                layout="vertical"
                size="large"
            >
                {/* 用户名输入框 */}
                <Form.Item
                    style={{ marginBottom: 20 }}
                    name="username"
                    rules={[{ required: true, message: "请输入用户名" }]}
                >
                    <Input
                        prefix={<UserOutlined className={styles.inputIcon} />}
                        placeholder="请输入用户名"
                        className={styles.customInput}
                        variant="borderless"
                    />
                </Form.Item>

                {/* 密码输入框 */}
                <Form.Item
                    style={{ marginBottom: 20 }}
                    name="password"
                    rules={[{ required: true, message: "请输入密码" }]}
                >
                    <Input.Password
                        prefix={<LockOutlined className={styles.inputIcon} />}
                        placeholder="请输入密码"
                        className={styles.customInput}
                        variant="borderless"
                    />
                </Form.Item>

                {/* 密码输入框 */}
                <Form.Item
                    style={{ marginBottom: 20 }}
                    name="confirmPassword"
                    rules={[
                        { required: true, message: "请确认密码" },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (
                                    !value ||
                                    getFieldValue("password") === value
                                ) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(
                                    new Error("两次输入的密码不匹配!")
                                );
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined className={styles.inputIcon} />}
                        placeholder="请确认密码"
                        className={styles.customInput}
                        variant="borderless"
                    />
                </Form.Item>

                {/* 验证码输入框 */}
                <Form.Item
                    style={{ marginBottom: 20 }}
                    name="captcha"
                    rules={[{ required: true, message: "请输入验证码" }]}
                >
                    <div className={styles.captchaRow}>
                        <Input
                            prefix={
                                <SafetyOutlined className={styles.inputIcon} />
                            }
                            placeholder="请输入验证码"
                            className={classNames(
                                styles.customInput,
                                styles.captchaInput
                            )}
                            variant="borderless"
                        />
                        <div
                            className={styles.captchaDisplay}
                            onClick={fetchCaptcha}
                        >
                            {captchaUrl && (
                                <img
                                    src={captchaUrl}
                                    alt="验证码"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </Form.Item>

                {/* 注册链接 */}
                <div className={styles.registerLink}>
                    <Link href="/login">已有账号？立即登录</Link>
                </div>

                {/* 注册按钮 */}
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className={styles.loginButton}
                        block
                    >
                        注册
                    </Button>
                </Form.Item>

                {/* 用户协议 */}
                <div className={styles.agreementText}>
                    <Text type="secondary">
                        注册即同意
                        <Link href="/user-agreement">《用户协议》</Link>和
                        <Link href="/privacy-policy">《隐私政策》</Link>
                    </Text>
                </div>
            </Form>
        </div>
    );
};

export default LoginForm;
